import { EapSettingsCreateModel } from 'modules/settings/pods/settings-devices/settings-devices-eap-settings/settings-devices-eap-settings-form/settings-devices-eap-settings-form.model';

const isNotEmpty = (value: string) => value.trim() !== '';

const isGeneralDataValid = (data: EapSettingsCreateModel) =>
    isNotEmpty(data.name) && isNotEmpty(data.ssid) && isNotEmpty(data.cipherType);

const isPasswordValid = (data: EapSettingsCreateModel, isEditMode: boolean) => {
    const hasPassword = isNotEmpty(data.password);
    const hasConfirm = isNotEmpty(data.confirmPassword);

    if (isEditMode && !hasPassword && !hasConfirm) {
        return true;
    }

    return hasPassword && hasConfirm && data.password === data.confirmPassword;
};

const isProtocolDataValid = (data: EapSettingsCreateModel, isEditMode: boolean) => {
    const baseValid = isNotEmpty(data.username) && isPasswordValid(data, isEditMode);

    if (data.eapType === 'TLS') {
        return baseValid && isNotEmpty(data.clientCertificateFilename) && isNotEmpty(data.clientPrivateKeyFilename);
    }

    return baseValid;
};

export const hasDataChanged = (current: EapSettingsCreateModel, initial: EapSettingsCreateModel): boolean => {
    const fieldsToCompare: (keyof EapSettingsCreateModel)[] = [
        'name',
        'ssid',
        'cipherType',
        'eapType',
        'username',
        'password',
        'confirmPassword',
        'anonymousUser',
        'caCertificateFilename',
        'clientCertificateFilename',
        'clientPrivateKeyFilename',
    ];

    return fieldsToCompare.some((field) => {
        const currentValue = current[field] ?? '';
        const initialValue = initial[field] ?? '';
        return currentValue !== initialValue;
    });
};

export const isFormDataValid = (data: EapSettingsCreateModel, isEditMode = false) =>
    isGeneralDataValid(data) && isProtocolDataValid(data, isEditMode);
